import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var configSettings = require('../../app-config/config');
var config = configSettings.GET_CONFIG();
import msalInstance from 'lib/msal';
import { appInsights } from 'lib/appInsight';

/**
 * @description Haldor Authentication class
 */
var Authentication = /*#__PURE__*/function () {
  function Authentication() {
    _classCallCheck(this, Authentication);
  }
  return _createClass(Authentication, [{
    key: "login",
    value:
    /**
     * @param {object} config Overwrites properties in default loginRequest
     * @description Execute login process
     */
    function login(config) {
      appInsights.trackTrace({
        message: "Authentication: User started login process"
      });
      localStorage.clear();
      var request = this.getRequest();
      if (config != null) {
        request = _objectSpread(_objectSpread({}, request), config);
      }
      msalInstance.loginRedirect(request);
    }

    /**
     * @description Handle login response
     * @returns 
     */
  }, {
    key: "handleLoginResponse",
    value: function handleLoginResponse() {
      return new Promise(function (resolve, reject) {
        msalInstance.handleRedirectPromise().then(function (authResult) {
          appInsights.trackTrace({
            message: "Authentication: User received login response"
          });
          if (authResult != null) {
            msalInstance.setActiveAccount(authResult.account);
            resolve();
          } else {
            appInsights.trackException({
              exception: new Error("Login: Handle response failed")
            });
            reject();
          }
        });
      });
    }

    /**
     * @description Sign out the user
     */
  }, {
    key: "logout",
    value: (function () {
      var _logout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              msalInstance.acquireTokenSilent(this.getRequest()).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
                  var logoutRequest;
                  return _regeneratorRuntime.wrap(function (_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        logoutRequest = {
                          account: response.account,
                          idTokenHint: response.idToken,
                          postLogoutRedirectUri: config.msal.postLogoutRedirectUri
                        };
                        _context.next = 1;
                        return msalInstance.logoutRedirect(logoutRequest);
                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }())
  }, {
    key: "getRequest",
    value: function getRequest() {
      var account = msalInstance.getActiveAccount();
      var request = {
        scopes: ["openid", "profile", "offline_access", "haldor.guardians"],
        account: account
      };
      return request;
    }

    /**
     * @description This method will return access_token
     */
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        var request = _this.getRequest();

        //Silently acquires an access token
        msalInstance.acquireTokenSilent(request).then(function (response) {
          resolve(response.accessToken);
        })["catch"](function (error) {
          // If user/client is offline, do not trigger event to login_required
          if (!window.navigator.onLine) {
            reject(error);
            return;
          }
          appInsights.trackTrace({
            message: "Authentication: AcquireTokenSilent failed"
          });
          appInsights.trackException({
            exception: error
          });
          if (error.message.indexOf('no_account_error') > -1) {
            appInsights.trackTrace({
              message: "Authentication: User does not have active account, taking user to login page"
            });
          } else {
            appInsights.trackTrace({
              message: "Authentication: This error is not handled"
            });
          }
          var event = new CustomEvent('login_required');
          document.dispatchEvent(event);
          console.log(error);
          reject(error);
        });
      });
    }
  }]);
}();
export default Authentication;